import styled from 'styled-components'

export const GroupRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  border-bottom: 1px solid ${({ theme }) => theme.color.base.c2};
`

export const GroupList = styled.div`
  padding-top: 12px;
  display: flex;
  flex-direction: column;
  max-height: 400px;
  overflow-y: auto;
`
